import i18n from "i18next";
import React, { Component } from "react";
import styled from "styled-components";
import { Bars } from "styled-icons/fa-solid/Bars";
import { RightArrow } from "styled-icons/boxicons-regular/RightArrow";
import { connect } from "react-redux";
import { withTranslation, Trans } from "react-i18next";
import Logout from "./Logout.png";
import Li1 from "./LanguageIcon/li-1.png";
import Li2 from "./LanguageIcon/li-2.png";
import Li3 from "./LanguageIcon/li-3.png";
import Li4 from "./LanguageIcon/li-4.png";
import Li5 from "./LanguageIcon/li-5.png";
import Li6 from "./LanguageIcon/li-6.png";
import Li7 from "./LanguageIcon/li-7.png";
import Li8 from "./LanguageIcon/li-8.png";
import Li10 from "./LanguageIcon/li-10.png";
import Li12 from "./LanguageIcon/li-12.png";
import Li14 from "./LanguageIcon/li-14.png";
import Li24 from "./LanguageIcon/li-24.png";
//import ProfilePic from "./profile-pic-header.png";
import { logoutUser, getUserInfo } from "../../../Actions";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu
} from "styled-dropdown-component";
import { APP_CODE_TIME } from "../../../Constants";
import ClickOutside from "react-simple-click-outside";
import { getTimesheetSecurity } from "../../../Actions/FetchTimesheetSecurity";

class Header extends Component {
  constructor(props) {
    super();
    this.state = {
      hidden: true,
      languageId: props.languageId,
      currentRoute: null
    };
  }

  componentDidMount() {
    if (this.props.isAuthenticated) {
      // Get User Info on load
      this.props.dispatch(getUserInfo({ onSuccess: this.loadLanguage }));
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location && this.props.location.pathname) {
      let pathSplit = this.props.location.pathname.split("/");
      if (
        pathSplit.length > 0 &&
        this.state.currentRoute !== pathSplit[pathSplit.length - 1]
      ) {
        this.setState({ currentRoute: pathSplit[pathSplit.length - 1] });
      }
    }
    if (this.props.defaultProfile !== prevProps.defaultProfile) {
      this.props.dispatch(
        getTimesheetSecurity({
          ssoId: this.props.ssoId,
          branchNumber: this.props.branchId
        })
      );
    }
    if (
      this.state.languageId &&
      this.props.languageId !== prevProps.languageId
    ) {
      this.loadLanguage(this.props.languageId);
    }
  }

  _toggle = () => {
    this.setState(prevState => {
      return { hidden: prevState.hidden };
    });
  };

  _close = target => {
    this.setState({
      [target]: true
    });
  };

  authRoutes = () => {
    this.props.history.push("/timetracking/" + this.props.ssoId + "/profile", {
      page: "profile"
    });
  };

  loadLanguage = langId => {
    this.setState({ languageId: langId });
    let backendOptions = i18n.services.backendConnector.backend.options;
    backendOptions.loadPath =
      backendOptions.addPath +
      this.props.branchId +
      "/" +
      langId +
      "/" +
      APP_CODE_TIME;
    backendOptions.requestOptions.body = JSON.stringify({
      BranchId: this.props.branchId,
      LanguageId: langId,
      appCd: APP_CODE_TIME,
      appCdTranslation: APP_CODE_TIME,
      ssoId: this.props.ssoId
    });
    backendOptions.requestOptions.headers = {
      contentType: "application/json",
      accept: "application/json, text/plain, application/vnd.ms-excel",
      appCd: APP_CODE_TIME,
      "Access-Control-Allow-Methods": "POST",
      "Access-Control-Allow-Origin": "*",
      sessionId: this.props.sessionId,
      ssoId: this.props.ssoId
    };
    i18n.changeLanguage(langId + "");
    this.setState({ hidden: true });
  };

  handleLogout = () => {
    let payload = {
      technicianId: this.props.ssoId,
      branchId: this.props.branchId,
      clckInOut: "OUT",
      reasonCd: "43",
      signedInBy: null,
      signedOutBy: this.props.ssoId,
      comments: null
    };
    if (
      this.props.defaultProfile.emplRole === "Workshop Manager" ||
      this.props.defaultProfile.emplRole === "Workshop Admin"
    ) {
      this.props.dispatch(logoutUser(payload));
    } else {
      this.props.history.push(
        "/timetracking/" + this.props.ssoId + "/technician/hourslogin"
      );
    }
  };

  handleOpenCloseDropdown() {
    this.setState({
      hidden: !this.state.hidden
    });
  }
  navigateUser = () => {
    this.props.defaultProfile.emplRole === "Workshop Manager" || this.props.defaultProfile.emplRole === "Workshop Admin"
      ? (this.props.defaultProfile.isMaintScehduling === "Y" ? this.props.history.push("/scheduling") : this.props.history.push("/workshop"))
      : this.props.history.push("/workshopTechnician");
  };
  getLangIcon(LangId) {
    if (LangId == 1) {
      return Li1;
    }
    else if (LangId == 2) {
      return Li2;
    }
    else if (LangId == 3) {
      return Li3;
    }
    else if (LangId == 4) {
      return Li4;
    }
    else if (LangId == 5) {
      return Li5;
    }
    else if (LangId == 6) {
      return Li6;
    }
    else if (LangId == 7) {
      return Li7;
    }
    else if (LangId == 8) {
      return Li8;
    }
    else if (LangId == 10) {
      return Li10;
    }
    else if (LangId == 12) {
      return Li12;
    }
    else if (LangId == 14) {
      return Li14;
    }
    else {
      return Li24;
    }
  }


  render() {
    const { user } = this.props;
    const { hidden, languageId, currentRoute } = this.state;
    return (
      <>
        {user && i18n.languages && (
          <Wrapper className="navbar">
            <div className="col-md-4 col-sm-4 col-4">
              <Hamburger
                onClick={() => {
                  this.navigateUser();
                }}
              >
                <Bars icon={["fas", "bars"]} style={{ color: "white" }} />
                <ArrowIcon icon={["fas", "caret-right"]} />
              </Hamburger>
              <HeadH1>
                <Trans>timeTrack</Trans>
              </HeadH1>
            </div>
            <RightIcons>
              <Dropdown className="col-2">
                <ClickOutside close={this._close} target="hidden">
                  <ImageDiv onClick={() => this.handleOpenCloseDropdown()}>
                    <img
                      src={this.getLangIcon(languageId)}
                
                      alt="Language"
                    />
                  </ImageDiv>

                  <DropDownMenu hidden={hidden}>
                    {user.Languages.map(({ languageId, languageName }) => (
                      <DropDownItem
                        onClick={() => this.loadLanguage(languageId)}
                        key={languageId}
                      >
                        <img
                          src={this.getLangIcon(languageId)}
                          alt={languageName}
                        />{" "}
                        {languageName}
                      </DropDownItem>
                    ))}
                  </DropDownMenu>
                </ClickOutside>
              </Dropdown>

              <NameTag className="col-6"> {this.props.userName}</NameTag>
              {/* <ProfileIcon className="col-3" //onClick={this.authRoutes}
              >
                <img src={ProfilePic} alt="Profile" />
              </ProfileIcon> */}

              {["hourslogin", "hoursadjustment&payment", "callouts"].indexOf(
                currentRoute
              ) === -1 && (
                <LogoutIcon onClick={this.handleLogout} className="col">
                  <img src={Logout} alt="Logo" />
                </LogoutIcon>
              )}
            </RightIcons>
          </Wrapper>
        )}
      </>
    );
  }
}

const mapStateToProps = ({ auth, fetchTimesheetSecurity }) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    user: auth.user,
    branchId: auth.user ? auth.user.defaultProfile.branchId : null,
    sessionId: auth.appData.sessionId,
    languageId: auth.user
      ? Number(auth.user.defaultProfile.defaultLanguage)
      : 1,
    userName: auth.appData.empName,
    timesheetSecurity: fetchTimesheetSecurity,
    defaultProfile: auth.user ? auth.user.defaultProfile : null
  };
};

export default connect(mapStateToProps)(withTranslation()(Header));

const Wrapper = styled.nav`
  && {
    align-self: flex-start;
    width: 100%;
    position: relative;
    border: 0;
    margin-bottom: 0;
    height: 60px;
    min-height: 60px;
    z-index: 10;
    background: #434f5b;
    padding: 0;
  }
`;
const Hamburger = styled.div`
  height: 60px;
  width: 60px;
  float: left;
  padding: 17px 20px 20px 20px;
  position: relative;
  color: #fff;
`;
const HeadH1 = styled.div`
  line-height: 55px;
  color: #fff;
  font-size: 18px;
  display: inline-block;
  float: left;
`;
const RightIcons = styled.div`
  color: white;
  float: right;
  padding-right: 0px !important;
  display: flex;
  width: 300px;
  height: 100%;
`;
const ArrowIcon = styled(RightArrow)`
  color: #f2c007;
  background: #434f5b;
  position: absolute;
  bottom: 23px;
  right: 14px;
  padding-left: 0px;
  font-size: 17px;
  height: 12px;
`;
// const ProfileIcon = styled.div`
//   padding-top: 8px;
//   margin-left: auto;
// `;
const LogoutIcon = styled.div`
  && {
    height: 60px;
    line-height: 32px;
    background-color: #37434b;
    cursor: pointer;
  }
  img {
    margin: 19px 5px 5px;
  }
`;
const DropDownMenu = styled(DropdownMenu)`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  float: left;
  min-width: 18.5rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: black;
  text-align: left;
  list-style: none;
  background-color: black;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  display: block;
`;
const DropDownItem = styled(DropdownItem)`
  padding: 0.75rem 1.5rem;
  clear: both;
  font-weight: 900;
  color: white;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
`;
const ImageDiv = styled.div`
  position: relative;
  top: 14px;
  cursor: pointer;
`;
const NameTag = styled.span`
  top: 15px;
  position: relative;
  right: 15px;
  font-size: 15px;
`;
